export const layersConfig = [
	// Map Styles
	{
		id: "map-style",
		label: "Map Style",
		isActive: true,
		icon: "🗺️",
	},

	// Personal Spaces
	{
		id: "personal-spaces",
		label: "Personal Spaces",
		isActive: false,
		icon: "🏠",
	},

	// Barriers
	{ id: "barriers", label: "Barriers", isActive: false, icon: "🚫" },

	// Housing
	{ id: "housing", label: "Housing", isActive: false, icon: "🏘️" },

	// Healthcare
	{ id: "healthcare", label: "Healthcare", isActive: false, icon: "🏥" },

	// Food & Nutrition
	{
		id: "food-nutrition",
		label: "Food & Nutrition",
		isActive: false,
		icon: "🍽️",
	},

	// Education
	{ id: "education", label: "Education", isActive: false, icon: "🎓" },

	// Community
	{ id: "community", label: "Community", isActive: false, icon: "🤝" },

	// Transportation
	{
		id: "transportation",
		label: "Transportation",
		isActive: false,
		icon: "🚌",
	},

	// Economic
	{ id: "economic", label: "Economic", isActive: false, icon: "💰" },

	// Obstacles
	{ id: "obstacles", label: "Obstacles", isActive: false, icon: "⚠️" },

	// Emotional States
	{
		id: "emotional-states",
		label: "Emotional States",
		isActive: false,
		icon: "💭",
	},
];
